<h2 mat-dialog-title>Assign asset to customer</h2>
<div mat-dialog-content class="assignment-content">
  <div class="assignment-asset"><strong>{{ data.asset.name || data.asset.basicName }}</strong><span>{{ data.asset.code }}</span></div>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Customer</mat-label>
    <mat-select required [(ngModel)]="targetCustomer" (selectionChange)="selectedCustomer($event)" [disabled]="saving">
      @for (available of customers | sort: 'basicName'; track available.id) {
        <mat-option [value]="available">{{ available.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (isScout) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Scout name</mat-label>
      <input matInput [(ngModel)]="name" required [disabled]="saving">
      <mat-hint>Name shown for this Scout under the selected customer.</mat-hint>
    </mat-form-field>
    <mat-slide-toggle [(ngModel)]="doScoutSensor" [disabled]="saving">Include attached assets</mat-slide-toggle>
  }
  @if (errorMessage) { <p class="assignment-error" role="alert">{{ errorMessage }}</p> }
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onNoClick()" [disabled]="saving">Cancel</button>
  <button mat-flat-button class="assignment-submit" (click)="onSubmit($event)"
    [disabled]="!targetCustomer || !typeReady || saving || (isScout && !name.trim())">{{ saving ? 'Assigning…' : 'Assign asset' }}</button>
</div>
